var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.owners_association !== null)?_c('Home',{attrs:{"owners_association":_vm.owners_association,"city_image":_vm.city_image},on:{"ongetAnnexDocuments":_vm.getAnnexDocuments,"ongetPaymentsDocuments":_vm.getPaymentsDocuments}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }